import { filesApi } from "@/lib/humhub-api/files";
import { downloadBlobAsFile } from "@/lib/utils/mediaFile";

export const downloadMediaFile = async ({
  guid,
  fileName,
}: {
  guid: string;
  fileName: string;
}) => {
  const blob = await filesApi.getFileByGuid(guid);
  downloadBlobAsFile({ blob, fileName });
};
